// Apple Table Style Overrides
// ─────────────────────────────────────────────────────────────────────────────

export default function Table(theme) {
  return {
    MuiTable: {
      styleOverrides: {
        root: {
          borderCollapse: 'separate',
          borderSpacing: 0,
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          backgroundColor: '#FFFFFF',
          fontWeight: 600,
          fontSize: 13,
          textTransform: 'uppercase',
          letterSpacing: 0.5,
          color: '#636366',
          borderBottom: '1px solid rgba(60,60,67,0.12)',
        },
        body: {
          borderBottom: '1px solid rgba(60,60,67,0.06)',
          fontSize: 15,
          padding: '14px 16px',
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&:hover': {
            backgroundColor: 'rgba(0,122,255,0.04)',
          },
        },
      },
    },
  };
}
